import type { FaireProductEntity } from "../../entity_types/product";

export const p_2udqmgaagz: FaireProductEntity = {
  token: "p_2udqmgaagz",
  type: "product",
  name: "Elephant print harem pant (TH-1023)",
  brandToken: "b_a990dearj1",
  brandName: "Kathmandu Imports",
  imageUrl:
    "https://cdn.faire.com/fastly/7c0d5563f55cc79acfaa44029e522b7282a038f3c52f58ff6621d58d93353363.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.25,
  description:
    "Elephant print harem pant with no elastic on the ankle\nFree Size\nAssorted Colors",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:18.471Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
